export enum HTTPCodes {
  LargePayload = 413,
  Unauthorized = 401,
  BadRequest = 400,
  Forbidden = 403,
  NotFound = 404,
  Conflict = 409,
}
